import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "screen-brightness"
  static values = { level: { type: Number, default: 1 } }

  connect() {
    super.connect()
    if (!this.enabled) return

    this.send("connect", { level: this.levelValue })
  }

  disconnect() {
    this.send("disconnect")
  }
}
